import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { FormControl, ReactiveFormsModule, Validators } from '@angular/forms';
import { MarkantElementsModule } from '@markant/elements-angular';
import { TranslocoModule } from '@jsverse/transloco';
import { AsyncPipe, NgIf } from '@angular/common';
import { FormControlErrorPipe, FormControlKeyErrorPipe } from '@markant-platform/shared/util-pipes';

@Component({
  selector: 'markant-platform-create-new-group',
  standalone: true,
  templateUrl: './create-new-group.component.html',
  styleUrls: ['./create-new-group.component.scss'],
  imports: [
    MarkantElementsModule,
    TranslocoModule,
    ReactiveFormsModule,
    NgIf,
    AsyncPipe,
    FormControlErrorPipe,
    FormControlKeyErrorPipe,
  ],
})
export class CreateNewGroupComponent implements OnInit {
  @Output() openChange = new EventEmitter<boolean>();
  @Output() createGroup = new EventEmitter<string>();

  groupNameInput!: FormControl;

  ngOnInit(): void {
    this.groupNameInput = new FormControl('', [Validators.required, Validators.maxLength(50)]);
  }

  closeDialog(): void {
    this.openChange.emit(false);
  }

  onCreateGroup(): void {
    if (this.groupNameInput.invalid) {
      this.groupNameInput.markAsTouched();
      return;
    }
    this.createGroup.emit(this.groupNameInput.value);
    this.groupNameInput.reset();
    this.closeDialog();
  }
}
